import { fmtAUD } from './formatCurrency';

export function buildBudgetSuggestions(allTxns, currentBudgets, expenseMap, incomeList, selMonth, selYear) {
  const priorKeys = [];
  for (let i = 1; i <= 3; i++) {
    let m = selMonth - i;
    let y = selYear;
    if (m < 0) { m += 12; y--; }
    priorKeys.push(y + '-' + String(m + 1).padStart(2, '0'));
  }

  const byMonthCat = {};
  for (const t of (allTxns || [])) {
    if (!t || !t.date || !t.category) continue;
    if (incomeList && incomeList.includes(t.category)) continue;
    const d = new Date(t.date);
    const key = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
    if (!priorKeys.includes(key)) continue;
    const cat = t.category;
    if (!byMonthCat[key]) byMonthCat[key] = {};
    byMonthCat[key][cat] = (byMonthCat[key][cat] || 0) + (Number(t.amount) || 0);
  }

  const budgetedCats = Object.values(expenseMap || {}).flat();
  const raise = [];
  const lower = [];

  for (const cat of budgetedCats) {
    const budget = Number(currentBudgets[cat]) || 0;
    if (budget <= 0) continue;

    const monthAmounts = priorKeys
      .map(k => (byMonthCat[k] || {})[cat] || 0)
      .filter(v => v > 0);

    if (monthAmounts.length < 2) continue;

    const avg = monthAmounts.reduce((s, v) => s + v, 0) / monthAmounts.length;
    if (avg < 20) continue;

    const diff = avg - budget;

    if (avg > budget * 1.1 && diff > 20) {
      const suggested = Math.round(avg / 10) * 10;
      raise.push({
        type: 'raise',
        category: cat,
        currentBudget: budget,
        suggestedBudget: suggested,
        avg3mo: avg,
        icon: '💡',
        color: '#f59e0b',
        text: cat + ': avg $' + fmtAUD(avg) + '/mo over 3 months, budget is $' + fmtAUD(budget) +
          '. Consider raising to $' + fmtAUD(suggested) + '.',
      });
    } else if (avg < budget * 0.6 && budget > 30 && budget - avg > 30) {
      const suggested = Math.round(avg * 1.2 / 10) * 10;
      lower.push({
        type: 'lower',
        category: cat,
        currentBudget: budget,
        suggestedBudget: suggested,
        avg3mo: avg,
        icon: '✂️',
        color: '#16a34a',
        text: cat + ': avg $' + fmtAUD(avg) + '/mo over 3 months — budget of $' + fmtAUD(budget) +
          ' has room to trim to $' + fmtAUD(suggested) + '.',
      });
    }
  }

  raise.sort((a, b) => (b.avg3mo - b.currentBudget) - (a.avg3mo - a.currentBudget));
  lower.sort((a, b) => (b.currentBudget - b.avg3mo) - (a.currentBudget - a.avg3mo));
  return [...raise, ...lower];
}
